import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LabTestIdentity } from './lab-test';
import { SponsorRouteData } from '../sponsor-route-data';
import { SponsorLabResultsStorage } from './sponsor-lab-results-storage';
import { publishLast, refCount } from 'rxjs/operators';

@Injectable()
export class LabTestsIdentitiesStorage {
    private testIdentities: Observable<LabTestIdentity[]>;

    constructor(
        private readonly routeData: SponsorRouteData,
        private readonly sponsorLabResultsStorage: SponsorLabResultsStorage,
    ) {
    }

    public get labTestsIdentities(): Observable<LabTestIdentity[]> {
        if (!this.testIdentities) {
            this.loadLabTestsIdentities();
        }
        return this.testIdentities;
    }

    private loadLabTestsIdentities() {
        this.testIdentities = this.sponsorLabResultsStorage
            .loadLabTestsIdentities(this.routeData.snapshot.selectedStudy)
            .pipe(
                publishLast(),
                refCount()
            );
    }
}